import React, { FC, ReactNode, useEffect, useState } from 'react';
import { APP_MODE_PARAM, APP_MODE_ID } from 'src/constants/common';

import { cookieManager } from '../../services/cookies';
import useQueryParams from '../../hooks/use-query-params';
import { setLSValue } from '../../utils/locale-storage';
import { checkIsBot } from '../../utils/bot';
import analytics from '../../services/analytics';

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const EXPIRES_AT = 3 * 60 * 60 * 1000; // 3 hours

type Props = {
  children: ReactNode;
};

const AppModeMiddleware: FC<Props> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  const { getQueryParams, removeQueryParam } = useQueryParams();

  useEffect(() => {
    (async () => {
      try {
        const queryParams = getQueryParams();
        const quizId = queryParams?.[APP_MODE_PARAM];
        const isBot = checkIsBot();
        const isCompliance = quizId !== APP_MODE_ID || isBot;

        analytics.setUserProperties({
          quiz_mode: isCompliance ? 'compliance' : 'force_quiz',
        });

        if (!isCompliance) {
          cookieManager.writeCookie(APP_MODE_PARAM, APP_MODE_ID, {
            expires: new Date(Date.now() + EXPIRES_AT),
            secure: true,
            sameSite: 'Lax',
            path: '/',
          });

          setLSValue(APP_MODE_PARAM, APP_MODE_ID);
          removeQueryParam(APP_MODE_PARAM);
        }
      } catch (e: unknown) {
        console.error(`Failed to set app mode: ${e}`);
      } finally {
        setIsLoading(false);
      }
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return null;
  }

  return <>{children}</>;
};

export { AppModeMiddleware };
